import { render, staticRenderFns } from "./UserBirthdays.vue?vue&type=template&id=1d353e80&"
import script from "./UserBirthdays.vue?vue&type=script&lang=js&"
export * from "./UserBirthdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports